import { Navigate, Route, Routes } from 'react-router-dom'
import PublicLayout from './components/PublicLayout'
import Home from './pages/public/Home'
import HowItWorks from './pages/public/HowItWorks'
import ForClients from './pages/public/ForClients'
import Contact from './pages/public/Contact'
import Privacy from './pages/public/Privacy'
import OptOut from './pages/public/OptOut'
import MeetingChange from './pages/public/MeetingChange'
import Booking from './pages/public/Booking'
import Login from './pages/public/Login'
import AppLayout from './pages/app/AppLayout'
import Overview from './pages/app/Overview'
import Companies from './pages/app/Companies'
import CompanyDetail from './pages/app/CompanyDetail'
import Inbox from './pages/app/Inbox'
import KillSwitch from './pages/app/KillSwitch'
import Spend from './pages/app/Spend'
import Prompts from './pages/app/Prompts'
import Demos from './pages/app/Demos'
import GlobalActivity from './pages/app/GlobalActivity'
import Engagements from './pages/app/Engagements'
import RequireAuth from './components/RequireAuth'

export default function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<Home />} />
        <Route path="how-it-works" element={<HowItWorks />} />
        <Route path="clients" element={<ForClients />} />
        <Route path="contact" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="opt-out" element={<OptOut />} />
        <Route path="meeting" element={<MeetingChange />} />
        <Route path="book" element={<Booking />} />
        <Route path="login" element={<Login />} />
      </Route>

      <Route
        path="app"
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Overview />} />
        <Route path="companies" element={<Companies />} />
        <Route path="engagements" element={<Engagements />} />
        <Route path="companies/:companyId" element={<CompanyDetail />} />
        <Route path="spend" element={<Spend />} />
        <Route path="workflows" element={<Navigate to="/app/companies" replace />} />
        <Route path="prompts" element={<Prompts />} />
        <Route path="demos" element={<Demos />} />
        <Route path="activity" element={<GlobalActivity />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="controls" element={<KillSwitch />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
